import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const SkeletonCard = styled.div`
  padding: 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  min-width: 200px;
  flex: 1;
`;

const SkeletonRow = styled.div`
  display: flex;
  gap: 16px;
  margin: 0 -16px;
  margin-bottom: 24px;
  padding: 0 16px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 2px;
  }
`;

const SummarySkeleton = () => (
  <SkeletonRow>
    {[1, 2, 3, 4, 5, 6].map((index) => (
      <SkeletonCard key={index}>
        <Skeleton active paragraph={{ rows: 1 }} />
      </SkeletonCard>
    ))}
  </SkeletonRow>
);

export default SummarySkeleton; 